import React from "react";
import { Undo2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { Requirement } from "../../redux/interfaces/folder.types.ts";
import { setActivePanels } from "../../redux/slices/vaultSlice.ts";
import { useCancelToReview } from "../../hooks/vault/mutations/useCancelToReview.ts";
import { Button } from "../ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";

interface Props {
  requirement: Requirement;
}

export const CancelToReview: React.FC<Props> = ({ requirement }) => {
  const dispatch = useAppDispatch();
  const { activeVault } = useAppSelector((state) => state.vault);
  const mutation = useCancelToReview(activeVault?.id);

  const onCancelToReview = async () => {
    mutation.mutate(requirement.id, {
      onSuccess: () => {
        dispatch(setActivePanels([requirement.id]));
      },
      onError: (error: any) => {
        toast.error(error?.message ?? "Error al cancelar el envío a revisión");
      },
    });
  };

  return (
    <div className="mt-2">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" disabled={mutation.isPending}>
            {mutation.isPending ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Undo2 className="h-4 w-4" />
            )}
            Deshacer el envío a revisión
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              ¿Estás seguro de deshacer el envío a revisión?
            </AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2">
                <p>
                  Esta acción te permitirá modificar la información que enviaste
                  a revisión.
                </p>
                <p>
                  Una vez que la modifiques, puedes enviar de nuevo el
                  requisito.
                </p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={onCancelToReview}>
              Aceptar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
